<template>
  <div class="pie-chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  name: 'CallLogByStatusPieChart',
  props: {
    callLogs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      if (this.callLogs.length === 0) return;

      const answeredCount = this.callLogs.filter(call => call.call_status === 'completed').length;
      const failedCount = this.callLogs.filter(call => call.call_status === 'failed').length;

      this.renderChart(
        {
          labels: [
            this.$t('CALL_LOG_REPORT.STATUS.COMPLETED'),
            this.$t('CALL_LOG_REPORT.STATUS.FAILED'),
          ],
          datasets: [{
            data: [answeredCount, failedCount],
            backgroundColor: ['#10b981', '#ef4444'],
            borderWidth: 2,
            borderColor: '#fff',
          }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
            },
          },
        }
      );
    },
  },
  watch: {
    callLogs: {
      immediate: true,
      handler() {
        if (this.callLogs.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.pie-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>